// extracted by mini-css-extract-plugin
export default {"not_found_page__wrapper":"styles_not_found_page__wrapper__xnLZU","not_found_page__image":"styles_not_found_page__image__MZhLQ"};